import { motion } from "framer-motion";
function OptionCard({ option, onClick }) {
  return (
    <motion.button
      whileHover={{ y: -4, scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className="overflow-hidden relative w-full h-full text-left bg-white rounded-xl sm:rounded-2xl ring-1 ring-gray-200 shadow-sm transition-all duration-300 cursor-pointer group focus:outline-none hover:shadow-xl hover:ring-2 hover:ring-emerald-400 focus:ring-2 focus:ring-emerald-400"
    >
      <div className="flex flex-col h-full p-3 sm:p-4 md:p-6">
        {/* Image container */}
        <div className="flex flex-1 justify-center items-center mb-3 sm:mb-4 min-h-[100px] sm:min-h-[120px] md:min-h-[140px]">
          <div className="overflow-hidden relative rounded-lg w-32 sm:w-32 md:w-48 aspect-square">
            <img
              src={option.image}
              alt={option.title}
              className="object-cover w-full h-full transition-all duration-300 group-hover:scale-110"
            />
          </div>
        </div>

        {/* Content */}
        <div className="flex-shrink-0 text-center space-y-1 sm:space-y-1.5">
          <h4 className="text-sm sm:text-base md:text-lg font-semibold text-gray-900 line-clamp-1">
            {option.title}
          </h4>
          <p className="text-xs sm:text-sm leading-relaxed text-gray-600 line-clamp-2">
            {option.subtitle}
          </p>
        </div>

        {/* Hover effect overlay */}
        <div className="absolute inset-0 bg-gradient-to-b transition-all duration-300 pointer-events-none from-emerald-50/0 via-emerald-50/0 to-emerald-50/0 group-hover:from-emerald-50/20 group-hover:via-emerald-50/10 group-hover:to-emerald-50/20" />
      </div>
    </motion.button>
  );
}

export default OptionCard;
